module.exports = __webpack_public_path__ + "static/media/exchange-recommendations-1.71cba72b.png";